import React from 'react';
import { useHistory } from "react-router-dom";
import * as PATH from '../../../lib/routes/path';

import HePrivacyConsent from './HePrivacyConsent';
import HeFinalProductList from './HeFinalProductList';

export const HeResultView = ({ data: workspace }) => {
  const history = useHistory();

  if (!workspace) {
    history.push(PATH.HOME);
    return <></>;
  }

  if (!workspace.isPrivacyConsented) {
    return (
      <HePrivacyConsent 
        workspace={workspace}
      />
    );
  } else {
    return (
      <HeFinalProductList 
        workspace={workspace} 
      />
    );
  }
}

export default React.memo(HeResultView);